import type { BundleMessageNote } from './BundleMessageNote.js';
import type { BundleMessageLocation } from './BundleMessageLocation.js';

export interface BundleMessage {
  pluginName?: string;
  type?: string;
  text: string;
  location?: BundleMessageLocation;
  notes?: BundleMessageNote[];
}
